<template>
  <div class="home">
    <MeetingForm></MeetingForm>
  </div>
</template>

<script>
import MeetingForm from './MeetingForm.vue';

export default {
  components:{
    MeetingForm
  }
}
</script>

<style lang="scss" scoped src="@/styles/style-home.scss">


